import React, { useState } from 'react';
import { ScrollView, StyleSheet, Text, View } from 'react-native';
import { useWindowDimensions } from 'react-native';
import { ProgramType } from 'utils/enum';
import { calcSizeForDevice, calcSizeForTv } from 'utils/index';

import { SEARCH_MENU_OPTION } from './index';

import Button from 'components/Button';
import FocusView from 'components/FocusView';
import { Icons } from 'components/Icons';
import SearchVerticalList from 'components/Section/SearchVerticalList';
import TvKeyboard from 'components/TvKeyboard';
import { WebDiv } from 'components/WebDiv';

const SearchTV: React.FC = () => {
  const [textValue, setTextValue] = useState('');
  const [categoryValue, setCategoryValue] = useState<ProgramType>();

  const { width: windowWidth } = useWindowDimensions();
  const containerLeftWidth = windowWidth - calcSizeForTv(600); // 600 => left area (keyboard, menus)

  const iconSize = {
    width: calcSizeForDevice(24).toString(),
    height: calcSizeForDevice(24).toString(),
  };

  return (
    <FocusView trapFocusUp trapFocusRight style={{ flex: 1 }}>
      <View style={styles.container}>
        <FocusView trapFocusUp trapFocusDown>
          <WebDiv
            className="navigation-container"
            style={{
              height: '100%',
              overflow: 'hidden',
              width: calcSizeForTv(360),
            }}>
            <View style={styles.searchHeader}>
              <Icons.MagnifyinGlass {...iconSize} />
              <Text style={styles.searchHeaderText}>{textValue || 'Principais Pesquisas'}</Text>
            </View>
            <TvKeyboard variant="simple" textValue={textValue} setTextValue={setTextValue} />
            <View />

            <ScrollView showsVerticalScrollIndicator={false} style={styles.menuScrollView}>
              {SEARCH_MENU_OPTION.map((item, index) => (
                <Button
                  role="button"
                  key={`${item?.title}-${index}`}
                  useTVFocus
                  variant="solid"
                  onPress={() => setCategoryValue(item?.value)}
                  backgroundColor="transparent"
                  size="sm"
                  style={{
                    justifyContent: 'center',
                    marginBottom: calcSizeForTv(10),
                    borderColor: categoryValue === item?.value ? '#7A8CFF' : 'transparent',
                    borderWidth: 1,
                    paddingHorizontal: calcSizeForTv(20),
                    paddingVertical: calcSizeForTv(10),
                  }}
                  textStyle={{
                    fontSize: calcSizeForTv(20),
                    fontWeight: categoryValue === item?.value ? 700 : 400,
                  }}
                  isFullWidth>
                  {item?.title}
                </Button>
              ))}
            </ScrollView>
          </WebDiv>
        </FocusView>
        <View style={[styles.resultsContainer, { width: containerLeftWidth }]}>
          <WebDiv className="navigation-container">
            <View style={styles.resultsContent}>
              <SearchVerticalList
                searchInputValue={textValue}
                categoryValue={categoryValue}
                containerWidth={containerLeftWidth}
              />
            </View>
          </WebDiv>
        </View>
      </View>
    </FocusView>
  );
};

export default SearchTV;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    height: '100%',
    width: '100%',
    display: 'flex',
    maxWidth: '100%',
    maxHeight: '100%',
    flexDirection: 'row',
    alignItems: 'flex-start',
    paddingLeft: calcSizeForTv(60),
    paddingRight: calcSizeForTv(60),
  },
  searchHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: calcSizeForTv(20),
    paddingTop: calcSizeForTv(60),
  },
  searchHeaderText: {
    fontSize: calcSizeForTv(30),
    color: 'white',
    lineHeight: calcSizeForTv(40),
    marginLeft: calcSizeForTv(20),
  },
  menuScrollView: {
    marginTop: calcSizeForTv(20),
  },
  resultsContainer: {
    flex: 1,
    height: '100%',
    maxHeight: '100%',
    overflow: 'hidden',
    marginLeft: calcSizeForTv(64),
  },
  resultsContent: {
    paddingTop: calcSizeForTv(60),
  },
});
